module.exports = __webpack_public_path__ + "04_medium_brown.44c09e7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer5/04_medium_brown.png
// module id = lCKP
// module chunks = 0